import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GoogleAnalytics from '../seo/GoogleAnalytics';
import VisitorTracking from '../seo/VisitorTracking';

export default function MainLayout() {
  return (
    <>
      <GoogleAnalytics />
      <VisitorTracking />
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
